export const UPDATE_FILTERS = "app/ROTA/UPDATE_FILTERS";
export const TOGGLE_FILTER_MODAL = "app/Roster/TOGGLE_FILTER_MODAL";
export const TOGGLE_DELETE_FILTER = "app/Roster/TOGGLE_DELETE_FILTER";

export const SAVE_FILTER = "app/ROTA/SAVE_FILTER";
export const SAVE_FILTER_SUCCESS = "app/ROTA/SAVE_FILTER_SUCCESS";
export const SAVE_FILTER_FAILURE = "app/ROTA/SAVE_FILTER_FAILURE";

export const GET_FILTERS = "app/ROTA/GET_FILTERS";
export const GET_FILTERS_SUCCESS = "app/ROTA/GET_FILTERS_SUCCESS";
export const GET_FILTERS_FAILURE = "app/ROTA/GET_FILTERS_FAILURE";

export const DELETE_FILTER = "app/ROTA/DELETE_FILTER";
export const DELETE_FILTER_SUCCESS = "app/ROTA/DELETE_FILTER_SUCCESS";
export const DELETE_FILTER_FAILURE = "app/ROTA/DELETE_FILTER_FAILURE";

export const UPDATE_SELECTED_FILTER = "app/ROTA/UPDATE_SELECTED_FILTER";
